import { render, staticRenderFns } from "./ContractClient.vue?vue&type=template&id=ebbc185a&scoped=true"
import script from "./ContractClient.vue?vue&type=script&lang=js"
export * from "./ContractClient.vue?vue&type=script&lang=js"
import style0 from "./ContractClient.vue?vue&type=style&index=0&id=ebbc185a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbc185a",
  null
  
)

export default component.exports